const parentElement = document.getElementById( 'sidebar' );
if ( parentElement !== null && 0 < parentElement.length ) {
	const selectElement = parentElement.querySelector( '.wc-block-product-categories.is-dropdown .wc-block-product-categories__dropdown select' );
	const buttonElement = parentElement.querySelector( '.wc-block-product-categories.is-dropdown .wc-block-product-categories__button' );

	if ( 0 < selectElement.length && 0 < buttonElement.length ) {
		selectElement.addEventListener( 'change', () => {
			buttonElement.click();
		} );
	}
}
